import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BuilderContext, useDrawer } from "react-flow-builder";
import {
  Form,
  Button,
  Input,
  Select,
  Radio,
  Checkbox,
  Modal,
  message,
} from "antd";
import { store } from "../../../../../../../redux";
import { setDraft } from "../../../../../../../redux/actions/skill";
import { colorcodes } from "../../../../../../../utility/colorCodes";
import { v4 as uuid } from "uuid";
import { notify } from "../../../../../../../redux/actions/snackActions";
import DeleteIcon from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import { GenAIConfigurer } from "./genaiConfigurer";
import CodeEditor from "@uiw/react-textarea-code-editor";
import info from "../../../../../../../images/info.png";
import sampleData from "../../sampleData.json";
import CopyToClipboard from "react-copy-to-clipboard";
import { CopyOutlined } from "@ant-design/icons";

const { Option } = Select;

const ExcelConfig = () => {
  const dispatch = useDispatch();
  let { selectedNode: node, flowVariables, nodes } = useContext(BuilderContext);
  // const [{ node, nodes }, setNodes] = useState({ node: DNode, nodes: DNodes })

  const { closeDrawer: cancel } = useDrawer();
  const [nodeData, setNodeData] = useState(node ?? {});
  const [actionType, setActionType] = useState(node.actionType ?? "");
  const variables = useSelector(
    (state) => state.skillReducer?.trainDraft?.RAW_DATA?.variables
  );
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [codeContent, setCodeContent] = useState("");
  const [filterContent, setFilterContent] = useState("");
  const [sortContent, setSortContent] = useState("");
  const [getCellContent, setGetCellContent] = useState("");
  const [getRowContent, setGetRowContent] = useState("");
  const [getColumnContent, setGetColumnContent] = useState("");
  const [getSheetContent, setGetSheetContent] = useState("");
  const [copySuccess, setCopySuccess] = useState(false);
  const [getRangeOptions, setGetRangeOptions] = useState({
    excludeHeaders: false,
    values: false,
    textFormat: false,
  });

  //  const [nodeData, setNodeData] = useState({});

  // function findObjectById(array, id) {
  //   function search(array, id) {
  //     for (let obj of array) {
  //       if (obj.id === id) {
  //         return obj;
  //       }
  //       if (obj.children) {
  //         let result = search(obj.children, id);
  //         if (result) {
  //           return result;
  //         }
  //       }
  //     }
  //     return null;
  //   }

  //   return search(array, id);
  // }

  // useEffect(() => {
  //   if (node && nodes) {
  //     const newNode = findObjectById(nodes, node.id)
  //     if (newNode) {
  //       setNodes(prevState => {
  //         return {
  //           ...prevState,
  //           node: newNode
  //         }
  //       })
  //       setNodeData(prevState => {
  //         return {
  //           ...nodeData,
  //           ...newNode
  //         }
  //       })
  //     }
  //   }
  // }, [store.getState().skillReducer])

  // useEffect(() => {
  //   handleSubmit(true)
  // }, [nodeData])

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const success = () => {
    message.success("Copied to clipboard");
  };

  useEffect(() => {
    const headers = [
      "GET_RANGE",
      "FILTER_COLUMNS",
      "SORT_EXCEL_COLUMN",
      "GET_CELL",
      "GET_ROW",
      "GET_COLUMN",
      "GET_SHEETNAMES",
    ];

    const setContent = (key, index) => {
      const { data, Example } = sampleData[index][key];
      const content = `Output variable to capture the response.\nBelow is the sample response.\n\n${JSON.stringify(
        data,
        null,
        2
      )}\n\n${Example}`;
      return content;
    };

    const setters = {
      GET_RANGE: setCodeContent,
      FILTER_COLUMNS: setFilterContent,
      SORT_EXCEL_COLUMN: setSortContent,
      GET_CELL: setGetCellContent,
      GET_ROW: setGetRowContent,
      GET_COLUMN: setGetColumnContent,
      GET_SHEETNAMES: setGetSheetContent,
    };

    headers.forEach((key, index) => {
      const content = setContent(key, index + 1);
      const setter = setters[key];
      if (setter && content) {
        setter(content);
      }
    });
  }, []);

  const findAndUpdate = (arr, id, payload) => {
    let found = arr.findIndex((i) => i.id == id);
    if (found > -1) {
      arr[found] = { ...arr[found], ...payload };
    } else {
      arr.forEach((element) => {
        if (
          [
            "branch",
            "condition",
            "loop",
            "loop-nodes",
            "try",
            "try-catch-node",
            "review",
            "review-node",
          ].includes(element.type)
        ) {
          findAndUpdate(element.children, id, payload);
        }
      });
    }
    return arr;
  };

  const validateVariableName = (variableName) => {
    if (
      (variableName && variableName.includes("-")) ||
      variableName.includes(" ")
    ) {
      return false;
    }
    return true;
  };
  const newVariables = useSelector(
    (state) => state.skillReducer?.trainDraft?.RAW_DATA?.variables
  );
  const checkForDuplicateVariable = (userVariable) => {
    const variableExists = newVariables?.some(
      (variable) =>
        variable.id !== nodeData.id && variable.name === userVariable
    );
    if (variableExists) {
      dispatch(notify("error", "Duplicate variable names are not allowed."));
      return false;
    }
    return true;
  };

  const addBackticks = (variable) => {
    // Check if variable is already enclosed in backticks
    if (!variable.startsWith("`") && !variable.endsWith("`")) {
      return `\`${variable}\``; // Add backticks
    } else {
      return variable; // Variable already has backticks, return as it is
    }
  };

  const handleSubmit = async (validate) => {
    try {
      let values;
      if (validate === false) {
        values = form.getFieldsValue();
      } else {
        values = await form.validateFields();
        if (values.variableName == null) {
        } else if (!validateVariableName(values.variableName)) {
          dispatch(
            notify(
              "error",
              "Invalid variable name. The use of '-' symbol and spaces are not allowed in variable names."
            )
          );
          return;
        }
      }
      let {
        skillReducer: { trainDraft },
      } = store.getState();

      // if (actionType === "OPEN_SPREADSHEET") {
      //   nodeData.actionType = "OPEN_SPREADSHEET";
      //   nodeData["filePath"] = values.filePath;
      // }
      if (actionType === "GET_SHEET_NAMES") {
        nodeData.actionType = "GET_SHEET_NAMES";
        nodeData["filePath"] = values.filePath;
        const userVariable = values.variableName;
        if (!checkForDuplicateVariable(userVariable)) {
          return;
        }
        nodeData["variableName"] = values.variableName;
      } else if (actionType === "GET_COLUMN") {
        nodeData.actionType = "GET_COLUMN";
        nodeData["filePath"] = values.filePath;
        const userVariable = values.variableName;
        if (!checkForDuplicateVariable(userVariable)) {
          return;
        }
        nodeData["variableName"] = values.variableName;
        nodeData["sheetName"] = values.sheetName;
        nodeData["columnAddress"] = values.columnAddress;
      } else if (actionType === "HIDE_COLUMN") {
        nodeData.actionType = "HIDE_COLUMN";
        nodeData["filePath"] = values.filePath;

        nodeData["sheetName"] = values.sheetName;
        nodeData["columnAddress"] = values.columnAddress;
      } else if (actionType === "DELETE_COLUMN") {
        nodeData.actionType = "DELETE_COLUMN";
        nodeData["filePath"] = values.filePath;

        nodeData["sheetName"] = values.sheetName;
        nodeData["columnAddress"] = values.columnAddress;
      } else if (actionType === "GET_ROW") {
        nodeData.actionType = "GET_ROW";
        nodeData["filePath"] = values.filePath;

        nodeData["sheetName"] = values.sheetName;
        nodeData["rowNumber"] = values.rowNumber;
        const userVariable = values.variableName;
        if (!checkForDuplicateVariable(userVariable)) {
          return;
        }
        nodeData["variableName"] = values.variableName;
      } else if (actionType === "DELETE_ROW") {
        nodeData.actionType = "DELETE_ROW";
        nodeData["filePath"] = values.filePath;

        nodeData["sheetName"] = values.sheetName;
        nodeData["rowNumber"] = values.rowNumber;
      } else if (actionType === "GET_CELL") {
        nodeData.actionType = "GET_CELL";
        nodeData["filePath"] = values.filePath;

        nodeData["sheetName"] = values.sheetName;
        nodeData["cellAddress"] = values.cellAddress;
        const userVariable = values.variableName;
        if (!checkForDuplicateVariable(userVariable)) {
          return;
        }
        nodeData["variableName"] = values.variableName;
      } else if (actionType === "GET_CELL_COLOR") {
        nodeData.actionType = "GET_CELL_COLOR";
        nodeData["filePath"] = values.filePath;

        nodeData["sheetName"] = values.sheetName;
        nodeData["cellAddress"] = values.cellAddress;
        const userVariable = values.variableName;
        if (!checkForDuplicateVariable(userVariable)) {
          return;
        }
        nodeData["variableName"] = values.variableName;
      } else if (actionType === "WRITE_CELL") {
        nodeData.actionType = "WRITE_CELL";
        if (values.filePath.match(/\\\\/)) {
          values.filePath = values.filePath;
        } else {
          var replacedfilePath = String.raw`${values.filePath}`.replace(
            /\\/g,
            "\\\\"
          );
          values.filePath = replacedfilePath;
        }
        nodeData["filePath"] = values.filePath;

        nodeData["sheetName"] = values.sheetName;
        nodeData["cellAddress"] = values.cellAddress;
        nodeData["cellValue"] = values.cellValue;
      } else if (actionType === "GET_RANGE") {
        nodeData.actionType = "GET_RANGE";
        nodeData["filePath"] = values.filePath;

        nodeData["sheetName"] = values.sheetName;
        nodeData["range"] = values.range;
        const userVariable = values.variableName;
        if (!checkForDuplicateVariable(userVariable)) {
          return;
        }
        nodeData["variableName"] = values.variableName;
      } else if (actionType === "WRITE_RANGE") {
        nodeData.actionType = "WRITE_RANGE";
        if (values.filePath.match(/\\\\/)) {
          values.filePath = values.filePath;
        } else {
          var replacedfilePath = String.raw`${values.filePath}`.replace(
            /\\/g,
            "\\\\"
          );
          values.filePath = replacedfilePath;
        }
        nodeData["filePath"] = values.filePath;

        nodeData["sheetName"] = values.sheetName;
        nodeData["range"] = values.range;
        nodeData["variableName"] = values.variableName
          ? addBackticks(values.variableName)
          : ""; // Check and add backticks
      } else if (actionType === "APPEND_RANGE") {
        nodeData.actionType = "APPEND_RANGE";
        if (values.filePath.match(/\\\\/)) {
          values.filePath = values.filePath;
        } else {
          var replacedfilePath = String.raw`${values.filePath}`.replace(
            /\\/g,
            "\\\\"
          );
          values.filePath = replacedfilePath;
        }
        nodeData["filePath"] = values.filePath;

        nodeData["sheetName"] = values.sheetName;
        nodeData["variableName"] = values.variableName
          ? addBackticks(values.variableName)
          : "";
      } else if (actionType === "REFRESH_EXCEL") {
        nodeData.actionType = "REFRESH_EXCEL";
        nodeData["filePath"] = values.filePath;
      } else if (actionType === "DELETE_RANGE") {
        nodeData.actionType = "DELETE_RANGE";
        nodeData["filePath"] = values.filePath;

        nodeData["sheetName"] = values.sheetName;
        nodeData["range"] = values.range;
      } else if (actionType === "GET_CELL_FORMULA") {
        nodeData.actionType = "GET_CELL_FORMULA";
        nodeData["filePath"] = values.filePath;

        nodeData["sheetName"] = values.sheetName;
        nodeData["cellAddress"] = values.cellAddress;
        const userVariable = values.variableName;
        if (!checkForDuplicateVariable(userVariable)) {
          return;
        }
        nodeData["variableName"] = values.variableName;
      } else if (actionType === "SET_RANGE_COLOR") {
        nodeData.actionType = "SET_RANGE_COLOR";
        if (values.filePath.match(/\\\\/)) {
          values.filePath = values.filePath;
        } else {
          var replacedfilePath = String.raw`${values.filePath}`.replace(
            /\\/g,
            "\\\\"
          );
          values.filePath = replacedfilePath;
        }
        nodeData["filePath"] = values.filePath;

        nodeData["sheetName"] = values.sheetName;
        nodeData["range"] = values.range;
        nodeData["color"] = values.color;
      } else if (actionType === "CONVERT_XLSX") {
        nodeData.actionType = "CONVERT_XLSX";
        nodeData["sourcePath"] = values.sourcePath;

        nodeData["fileName"] = values.fileName;
        nodeData["range"] = values.range;
      } else if (actionType === "INSERT_COLUMN") {
        nodeData.actionType = "INSERT_COLUMN";
        if (values.filePath.match(/\\\\/)) {
          values.filePath = values.filePath;
        } else {
          var replacedfilePath = String.raw`${values.filePath}`.replace(
            /\\/g,
            "\\\\"
          );
          values.filePath = replacedfilePath;
        }
        nodeData["filePath"] = values.filePath;

        nodeData["sheetName"] = values.sheetName;
        nodeData["noColumns"] = values.noColumns;
        nodeData["position"] = values.position;
      } else if (actionType === "CREATE_EXCEL") {
        nodeData.actionType = "CREATE_EXCEL";
        nodeData["filePath"] = values.filePath;

        nodeData["fileName"] = values.fileName;
      } else if (actionType === "FILTER_COLUMNS") {
        nodeData.actionType = "FILTER_COLUMNS";
        if (values.filePath.match(/\\\\/)) {
          values.filePath = values.filePath;
        } else {
          var replacedfilePath = String.raw`${values.filePath}`.replace(
            /\\/g,
            "\\\\"
          );
          values.filePath = replacedfilePath;
        }
        nodeData["filePath"] = values.filePath;

        nodeData["sheetName"] = values.sheetName;
        const userVariable = values.variableName;
        if (!checkForDuplicateVariable(userVariable)) {
          return;
        }
        nodeData["variableName"] = values.variableName;
      } else if (actionType === "CREATE_PIVOT_TABLE") {
        nodeData.actionType = "CREATE_PIVOT_TABLE";
        nodeData["filePath"] = values.filePath;

        nodeData["sheetName"] = values.sheetName;
        nodeData["tableRange"] = values.tableRange;
        nodeData["sheetTitle"] = values.sheetTitle;

        nodeData["pivotTable"] = nodeData.pivotTable;
      } else if (actionType === "SORT_EXCEL_COLUMN") {
        nodeData.actionType = "SORT_EXCEL_COLUMN";
        if (values.filePath.match(/\\\\/)) {
          values.filePath = values.filePath;
        } else {
          var replacedfilePath = String.raw`${values.filePath}`.replace(
            /\\/g,
            "\\\\"
          );
          values.filePath = replacedfilePath;
        }
        nodeData["filePath"] = values.filePath;

        nodeData["sheetName"] = values.sheetName;
        nodeData["columnAddress"] = values.columnAddress;
        const userVariable = values.variableName;
        if (!checkForDuplicateVariable(userVariable)) {
          return;
        }
        nodeData["variableName"] = values.variableName;
      } else if (actionType === "VLOOK_UP") {
        nodeData.actionType = "VLOOK_UP";
        if (values.filePath.match(/\\\\/)) {
          values.filePath = values.filePath;
        } else {
          var replacedfilePath = String.raw`${values.filePath}`.replace(
            /\\/g,
            "\\\\"
          );
          values.filePath = replacedfilePath;
        }
        nodeData["filePath"] = values.filePath;

        nodeData["sheetName"] = values.sheetName;
        nodeData["columnAddress"] = values.columnAddress;
        nodeData["columnIndex"] = values.columnIndex;
        const userVariable = values.variableName;
        if (!checkForDuplicateVariable(userVariable)) {
          return;
        }
        nodeData["variableName"] = values.variableName;
      } else if (actionType === "" || "select") {
        dispatch(notify("error", "Please select operation."));
        return;
      }

      nodes = nodes.filter((i) => !(i.isStart || i.isEnd));

      let newActions = findAndUpdate(nodes, nodeData.id, nodeData);

      store.dispatch(
        setDraft({
          ...trainDraft,
          RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
        })
      );
      if (validate === true) cancel();
    } catch (error) {
      console.log("form error: ", error.toString());
    }
  };

  const handleTypeChange = (e) => {
    if (e.target.value === "FILTER_COLUMNS") {
      nodeData["filters"] = [{ key: "", value: "" }];
      setNodeData(nodeData);
    }

    if (e.target.value === "CREATE_PIVOT_TABLE") {
      nodeData["pivotTable"] = [];
      setNodeData(nodeData);
    }
    setActionType(e.target.value);
  };

  const handleGetRangeChecks = (e, checkKey) => {
    let {
      skillReducer: { trainDraft },
    } = store.getState();

    nodeData[checkKey] = e.target.checked;
    nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
    let newActions = findAndUpdate(nodes, nodeData.id, nodeData);

    store.dispatch(
      setDraft({
        ...trainDraft,
        RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
      })
    );
  };

  const handleCheck = (e, checkKey) => {
    let {
      skillReducer: { trainDraft },
    } = store.getState();
    nodeData[checkKey] = e.target.checked == true ? "review" : "";
    nodes = nodes.filter((i) => !(i.isStart || i.isEnd));
    let newActions = findAndUpdate(nodes, nodeData.id, nodeData);

    store.dispatch(
      setDraft({
        ...trainDraft,
        RAW_DATA: { ...trainDraft.RAW_DATA, actions: newActions },
      })
    );
  };

  const deleteFilter = (index) => {
    let { filters } = nodeData;
    filters.splice(index, 1);

    setNodeData({ ...nodeData, filters: filters });
  };

  const addFilter = (filters) => {
    filters.push({ key: "", value: "" });
    setNodeData({ ...nodeData, filters: filters });
  };

  const handleChangeFilter = (e, index, filters) => {
    filters[index] = {
      ...filters[index],
      [e.target.name]: e.target.value,
    };

    setNodeData({ ...nodeData, filters: filters });
  };

  const pivotHandleChange = (e, id) => {
    let { pivotTable } = nodeData;
    if (pivotTable && pivotTable.length > 0) {
      let table = pivotTable.map((row) => {
        if (row.id === id) {
          return {
            ...row,
            [e.target.name]: e.target.value,
          };
        } else {
          return row;
        }
      });
      setNodeData({ ...nodeData, pivotTable: table });
    }
  };

  const addClick = (e) => {
    e.preventDefault();
    let { pivotTable } = nodeData;
    let table = [
      ...pivotTable,
      { id: uuid(), name: "", type: "ROW", function: "sum" },
    ];
    setNodeData({ ...nodeData, pivotTable: table });
  };

  const removeClick = (e) => {
    e.preventDefault();
    let { pivotTable } = nodeData;
    if (pivotTable && pivotTable.length > 0) {
      pivotTable.pop();
      setNodeData({ ...nodeData, pivotTable: pivotTable });
    }
  };

  const onRadioChange = (e) => {
    setNodeData({ ...nodeData, sortType: e.target.value });
  };

  // const [nodeConfig, setNodeConfig] = useState(node ?? {})
  // const handleFormItemInputChange = (evt) => {
  //   setNodeConfig(prevState => {
  //     return {
  //       ...prevState,
  //       [evt.target.name]: evt.target.value
  //     }
  //   })
  // }
  // useEffect(() => {
  //   form.setFieldsValue(node)
  // }, [node, form])

  const renderActionFields = (type) => {
    switch (type) {
      // case "OPEN_SPREADSHEET":
      //   return (
      //     <div>
      //       <Form.Item
      //         name="filePath"
      //         label="File Path (Include file name with extension)"
      //         help="Eg: D:\\NewFile.xlsx "
      //         rules={[{ required: true }]}
      //       >
      //         <Input />
      //       </Form.Item>
      //     </div>
      //   );

      case "GET_SHEET_NAMES":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="variableName"
              label="Variable Name"
              help="Eg: variableName"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <div style={{ position: "relative" }}>
              <div
                className="ip-tl-label"
                style={{
                  position: "absolute",
                  display: "inline-block",
                  margin: "0",
                  top: "-89px",
                  left: "93px",
                }}
              >
                <a
                  class="tlt-icon tl-tooltip task-table-info"
                  href="javascript:void(0)"
                  onClick={showModal}
                >
                  <img src={info} alt="" />
                </a>
              </div>
            </div>
            <Modal
              title="Reference"
              open={isModalOpen}
              onCancel={handleCancel}
              footer={null}
              style={{
                top: 20,
              }}
            >
              <CodeEditor value={getSheetContent} />
              <div style={{ position: "absolute", top: 10, right: 50 }}>
                <CopyToClipboard
                  text={getSheetContent}
                  onCopy={() => setCopySuccess(true)}
                >
                  <Button
                    onClick={success}
                    type="primary"
                    icon={<CopyOutlined />}
                  >
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
            </Modal>
          </div>
        );
      case "GET_COLUMN":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="sheetName"
              label="Sheet Name"
              help="Eg:Sheet1 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="columnAddress"
              label="Column Address or Number"
              help="Eg: A or B or 1 or 2 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="variableName"
              label="Variable Name"
              help="Eg: variableName"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item>
              <Checkbox
                onChange={(e) => handleCheck(e, "useFor")}
                checked={nodeData?.useFor}
              >
                {" "}
                Use For Review
              </Checkbox>{" "}
            </Form.Item>
            <div style={{ position: "relative" }}>
              <div
                className="ip-tl-label"
                style={{
                  position: "absolute",
                  display: "inline-block",
                  margin: "0",
                  top: "-89px",
                  left: "93px",
                }}
              >
                <a
                  class="tlt-icon tl-tooltip task-table-info"
                  href="javascript:void(0)"
                  onClick={showModal}
                >
                  <img src={info} alt="" />
                </a>
              </div>
            </div>
            <Modal
              title="Reference"
              open={isModalOpen}
              onCancel={handleCancel}
              footer={null}
              style={{
                top: 20,
              }}
            >
              <CodeEditor value={getColumnContent} />
              <div style={{ position: "absolute", top: 10, right: 50 }}>
                <CopyToClipboard
                  text={getColumnContent}
                  onCopy={() => setCopySuccess(true)}
                >
                  <Button
                    onClick={success}
                    type="primary"
                    icon={<CopyOutlined />}
                  >
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
            </Modal>
          </div>
        );

      case "GET_ROW":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="sheetName"
              label="Sheet Name"
              help="Eg:Sheet1 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="rowNumber"
              label="Row Number"
              help="Eg: 1 or 2 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="variableName"
              label="Variable Name"
              help="Eg: variableName"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item>
              <Checkbox
                onChange={(e) => handleCheck(e, "useFor")}
                checked={nodeData?.useFor}
              >
                {" "}
                Use For Review
              </Checkbox>{" "}
            </Form.Item>
            <div style={{ position: "relative" }}>
              <div
                className="ip-tl-label"
                style={{
                  position: "absolute",
                  display: "inline-block",
                  margin: "0",
                  top: "-89px",
                  left: "93px",
                }}
              >
                <a
                  class="tlt-icon tl-tooltip task-table-info"
                  href="javascript:void(0)"
                  onClick={showModal}
                >
                  <img src={info} alt="" />
                </a>
              </div>
            </div>
            <Modal
              title="Reference"
              open={isModalOpen}
              onCancel={handleCancel}
              footer={null}
              style={{
                top: 20,
              }}
            >
              <CodeEditor value={getRowContent} />
              <div style={{ position: "absolute", top: 10, right: 50 }}>
                <CopyToClipboard
                  text={getRowContent}
                  onCopy={() => setCopySuccess(true)}
                >
                  <Button
                    onClick={success}
                    type="primary"
                    icon={<CopyOutlined />}
                  >
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
            </Modal>
          </div>
        );

      case "GET_CELL":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="sheetName"
              label="Sheet Name"
              help="Eg:Sheet1 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="cellAddress"
              label="Cell Address"
              help="Eg: A1 or B2 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="variableName"
              label="Variable Name"
              help="Eg: variableName"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <div style={{ position: "relative" }}>
              <div
                className="ip-tl-label"
                style={{
                  position: "absolute",
                  display: "inline-block",
                  margin: "0",
                  top: "-89px",
                  left: "93px",
                }}
              >
                <a
                  class="tlt-icon tl-tooltip task-table-info"
                  href="javascript:void(0)"
                  onClick={showModal}
                >
                  <img src={info} alt="" />
                </a>
              </div>
            </div>
            <Modal
              title="Reference"
              open={isModalOpen}
              onCancel={handleCancel}
              footer={null}
              style={{
                top: 20,
              }}
            >
              <CodeEditor value={getCellContent} />
              <div style={{ position: "absolute", top: 10, right: 50 }}>
                <CopyToClipboard
                  text={getCellContent}
                  onCopy={() => setCopySuccess(true)}
                >
                  <Button
                    onClick={success}
                    type="primary"
                    icon={<CopyOutlined />}
                  >
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
            </Modal>
          </div>
        );

      case "WRITE_CELL":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="sheetName"
              label="Sheet Name"
              help="Eg:Sheet1 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="cellAddress"
              label="Cell Address"
              help="Eg: A1 or B2 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="cellValue"
              label="Cell Value"
              help="Eg: NewYork or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          </div>
        );

      case "DELETE_ROW":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="sheetName"
              label="Sheet Name"
              help="Eg:Sheet1 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="rowNumber"
              label="Row Number"
              help="Eg: 1 or 2 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          </div>
        );

      case "HIDE_COLUMN":
      case "DELETE_COLUMN":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="sheetName"
              label="Sheet Name"
              help="Eg:Sheet1 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="columnAddress"
              label="Column Address or Number"
              help="Eg: A or B or 1 or 2 or A,B or 1,2 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          </div>
        );

      case "GET_RANGE":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="sheetName"
              label="Sheet Name"
              help="Eg:Sheet1 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="range"
              label="Range"
              help="Eg: A1:B2 or `variableName`"
              // rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Checkbox
              onChange={(e) => handleGetRangeChecks(e, "excludeHeaders")}
              checked={nodeData.excludeHeaders}
            >
              {" "}
              Exclude Headers
            </Checkbox>
            <Checkbox
              onChange={(e) => handleGetRangeChecks(e, "values")}
              checked={nodeData.values}
            >
              {" "}
              Values
            </Checkbox>
            <Checkbox
              onChange={(e) => handleGetRangeChecks(e, "textFormat")}
              checked={nodeData.textFormat}
            >
              {" "}
              Text Format
            </Checkbox>
            <Form.Item
              name="variableName"
              label="Variable Name"
              help="Eg: variableName"
              rules={[
                { required: true, message: "Please input the variable name!" },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item>
              <Checkbox
                onChange={(e) => handleCheck(e, "useFor")}
                checked={nodeData?.useFor}
              >
                {" "}
                Use For Review
              </Checkbox>{" "}
            </Form.Item>

            <div style={{ position: "relative" }}>
              <div
                className="ip-tl-label"
                style={{
                  position: "absolute",
                  display: "inline-block",
                  margin: "0",
                  top: "-89px",
                  left: "93px",
                }}
              >
                <a
                  className="tlt-icon tl-tooltip task-table-info"
                  href="javascript:void(0)"
                  onClick={showModal}
                >
                  <img src={info} alt="" />
                </a>
              </div>
            </div>

            <Modal
              title="Reference"
              className="scrollable-modal"
              visible={isModalOpen}
              onCancel={handleCancel}
              footer={null}
              style={{
                top: 20,
              }}
            >
              <CodeEditor value={codeContent} />
              <div style={{ position: "absolute", top: 10, right: 50 }}>
                <CopyToClipboard
                  text={codeContent}
                  onCopy={() => setCopySuccess(true)}
                >
                  <Button
                    onClick={success}
                    type="primary"
                    icon={<CopyOutlined />}
                  >
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
            </Modal>
          </div>
        );

      case "FILTER_COLUMNS":
        const { filters } = nodeData;

        return (
          <div>
            <Form.Item
              name="filePath"
              label="File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="sheetName"
              label="Sheet Name"
              help="Eg:Sheet1 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Checkbox
              onChange={(e) =>
                setNodeData({
                  ...nodeData,
                  includeHeaders: e.target.checked,
                })
              }
              checked={nodeData.includeHeaders}
            >
              {" "}
              Include Headers
            </Checkbox>
            <div>
              {filters
                ? filters.map((obj, index) => (
                    <div style={{ display: "flex" }}>
                      <Input
                        margin="dense"
                        variant="outlined"
                        name="key"
                        placeholder="Column Name"
                        value={obj.key}
                        onChange={(e) => handleChangeFilter(e, index, filters)}
                        help="Eg: Country"
                      />
                      <Input
                        margin="dense"
                        variant="outlined"
                        name="value"
                        placeholder="Value"
                        value={obj.value}
                        onChange={(e) => handleChangeFilter(e, index, filters)}
                        help="Eg: India"
                      />
                      <IconButton
                        aria-label="Delete"
                        onClick={(e) => deleteFilter(index)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </div>
                  ))
                : null}

              <Button
                onClick={(e) => addFilter(filters)}
                variant="outlined"
                color="primary"
              >
                Add
              </Button>
            </div>

            <Form.Item
              name="variableName"
              label="Variable Name"
              help="Eg: variableName"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <div style={{ position: "relative" }}>
              <div
                className="ip-tl-label"
                style={{
                  position: "absolute",
                  display: "inline-block",
                  margin: "0",
                  top: "-89px",
                  left: "93px",
                }}
              >
                <a
                  class="tlt-icon tl-tooltip task-table-info"
                  href="javascript:void(0)"
                  onClick={showModal}
                >
                  <img src={info} alt="" />
                </a>
              </div>
            </div>
            <Modal
              title="Reference"
              open={isModalOpen}
              onCancel={handleCancel}
              footer={null}
              className="scrollable-modal"
              style={{
                top: 20,
              }}
            >
              <CodeEditor value={filterContent} />
              <div style={{ position: "absolute", top: 10, right: 50 }}>
                <CopyToClipboard
                  text={filterContent}
                  onCopy={() => setCopySuccess(true)}
                >
                  <Button
                    onClick={success}
                    type="primary"
                    icon={<CopyOutlined />}
                  >
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
            </Modal>
          </div>
        );

      case "WRITE_RANGE":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="sheetName"
              label="Sheet Name"
              help="Eg:Sheet1 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="range"
              label="Cell Address"
              help="Eg: A1 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="variableName"
              label="Select Variable"
              rules={[{ required: true }]}
            >
              <Select style={{ width: 120 }}>
                {variables
                  ?.filter((ele) => ele.dataType === "dataTable") // Filter to include only Data Table dataType variables
                  .map((ele, i) => (
                    <Option className="custom-select" key={i} value={ele.name}>
                      <p>{ele.name}</p>
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </div>
        );

      case "APPEND_RANGE":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="sheetName"
              label="Sheet Name"
              help="Eg:Sheet1 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="variableName"
              label="Select Variable"
              rules={[{ required: true }]}
            >
              <Select style={{ width: 120 }}>
                {variables
                  ?.filter((ele) => ele.dataType === "dataTable") // Filter to include only list dataType variables
                  .map((ele, i) => (
                    <Option className="custom-select" key={i} value={ele.name}>
                      <p>{ele.name}</p>
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </div>
        );

      case "REFRESH_EXCEL":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          </div>
        );

      case "DELETE_RANGE":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="sheetName"
              label="Sheet Name"
              help="Eg:Sheet1 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="range"
              label="Range"
              help="Eg: A1:B2 or `variableName`"
            >
              <Input />
            </Form.Item>
          </div>
        );

      case "GET_CELL_COLOR":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="sheetName"
              label="Sheet Name"
              help="Eg:Sheet1 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="cellAddress"
              label="Cell Address"
              help="Eg: A1 or B2 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="variableName"
              label="Variable Name"
              help="Eg: variableName"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <div style={{ position: "relative" }}>
              <div
                className="ip-tl-label"
                style={{
                  position: "absolute",
                  display: "inline-block",
                  margin: "0",
                  top: "-89px",
                  left: "93px",
                }}
              >
                <a
                  class="tlt-icon tl-tooltip task-table-info"
                  href="javascript:void(0)"
                  onClick={showModal}
                >
                  <img src={info} alt="" />
                </a>
              </div>
            </div>
            <Modal
              title="Reference"
              open={isModalOpen}
              onCancel={handleCancel}
              footer={null}
              style={{
                top: 20,
              }}
            >
              <CodeEditor
                value="Output variable to capture the response.
Below is the sample response:
FFFFC000"
              />
              <div style={{ position: "absolute", top: 10, right: 50 }}>
                <CopyToClipboard
                  text="Output variable to capture the response.
Below is the sample response:
FFFFC000"
                  onCopy={() => setCopySuccess(true)}
                >
                  <Button
                    onClick={success}
                    type="primary"
                    icon={<CopyOutlined />}
                  >
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
            </Modal>
          </div>
        );

      case "GET_CELL_FORMULA":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="sheetName"
              label="Sheet Name"
              help="Eg:Sheet1 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="cellAddress"
              label="Cell Address"
              help="Eg: A1 or B2 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="variableName"
              label="Variable Name"
              help="Eg: variableName"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <div style={{ position: "relative" }}>
              <div
                className="ip-tl-label"
                style={{
                  position: "absolute",
                  display: "inline-block",
                  margin: "0",
                  top: "-89px",
                  left: "93px",
                }}
              >
                <a
                  class="tlt-icon tl-tooltip task-table-info"
                  href="javascript:void(0)"
                  onClick={showModal}
                >
                  <img src={info} alt="" />
                </a>
              </div>
            </div>
            <Modal
              title="Reference"
              open={isModalOpen}
              onCancel={handleCancel}
              footer={null}
              style={{
                top: 20,
              }}
            >
              <CodeEditor
                value="Output variable to capture the response.
Below is the sample response:
=SUM(E2:E7)"
              />
              <div style={{ position: "absolute", top: 10, right: 50 }}>
                <CopyToClipboard
                  text="Output variable to capture the response.
Below is the sample response:
=SUM(E2:E7)"
                  onCopy={() => setCopySuccess(true)}
                >
                  <Button
                    onClick={success}
                    type="primary"
                    icon={<CopyOutlined />}
                  >
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
            </Modal>
          </div>
        );

      case "SET_RANGE_COLOR":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="sheetName"
              label="Sheet Name"
              help="Eg:Sheet1 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="range"
              label="Range"
              help="Eg: A1:B2 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item name="color" label="Color" rules={[{ required: true }]}>
              <Select
                // defaultValue=""
                style={{
                  width: 120,
                }}
              >
                {colorcodes.map((item) => (
                  <Option value={item.code}>{item.name}</Option>
                ))}
              </Select>
            </Form.Item>
          </div>
        );

      case "CONVERT_XLSX":
        return (
          <div>
            <Form.Item
              name="sourcePath"
              label="Source File Path (Include file name with extension)"
              help="Eg: D:\NewFile.csv or .xls or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="fileName"
              label="Destination File Path"
              help="Eg: D:\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          </div>
        );

      case "INSERT_COLUMN":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="sheetName"
              label="Sheet Name"
              help="Eg:Sheet1 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="noColumns"
              label="No of Columns"
              help="Eg: 1 or 2 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="position"
              label="Position"
              help="Eg: 1 or 2 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          </div>
        );

      case "SORT_EXCEL_COLUMN":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="sheetName"
              label="Sheet Name"
              help="Eg:Sheet1 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="columnAddress"
              label="Column Name"
              help="Eg: Name or Age or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="sortType"
              // label="Which contents to List?"
              rules={[{ required: true }]}
            >
              <Radio.Group>
                <Radio onChange={onRadioChange} value={"ascending"}>
                  Ascending
                </Radio>
                <Radio onChange={onRadioChange} value={"descending"}>
                  Descending
                </Radio>
              </Radio.Group>
            </Form.Item>

            <Form.Item
              name="variableName"
              label="Variable Name"
              help="Eg: variableName"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
            <div style={{ position: "relative" }}>
              <div
                className="ip-tl-label"
                style={{
                  position: "absolute",
                  display: "inline-block",
                  margin: "0",
                  top: "-89px",
                  left: "93px",
                }}
              >
                <a
                  class="tlt-icon tl-tooltip task-table-info"
                  href="javascript:void(0)"
                  onClick={showModal}
                >
                  <img src={info} alt="" />
                </a>
              </div>
            </div>
            <Modal
              title="Reference"
              open={isModalOpen}
              onCancel={handleCancel}
              footer={null}
              className="scrollable-modal"
              style={{
                top: 20,
              }}
            >
              <CodeEditor value={sortContent} />
              <div style={{ position: "absolute", top: 10, right: 50 }}>
                <CopyToClipboard
                  text={sortContent}
                  onCopy={() => setCopySuccess(true)}
                >
                  <Button
                    onClick={success}
                    type="primary"
                    icon={<CopyOutlined />}
                  >
                    Copy
                  </Button>
                </CopyToClipboard>
              </div>
            </Modal>
          </div>
        );

      case "CREATE_EXCEL":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="Folder Path"
              help="Eg: D:\\NewFolder or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="fileName"
              label="File Name"
              help="Eg: text.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          </div>
        );

      case "VLOOK_UP":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="File Path (Include file name with extension)"
              help="Eg: D:\\NewFile.xlsx or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="sheetName"
              label="Enter Sheet Name"
              rules={[{ required: true }]}
              help="Eg: Sheet1 or 'variableName`"
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="columnAddress"
              label="Cell Address or Number"
              help="Eg: A1 or B2 or `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="columnIndex"
              label="Column Index"
              rules={[{ required: true }]}
              help="Eg: 1 or 2 or `variableName` "
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="variableName"
              label="Variable Name"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          </div>
        );

      case "CREATE_PIVOT_TABLE":
        return (
          <div>
            <Form.Item
              name="filePath"
              label="Enter Full Path"
              help="please give variable name as `variableName`"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="sheetName"
              label="Enter Sheet Name"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="tableRange"
              label="Table Range (Optional)"
              help="Eg: R1C1:R5C3 (in this R=Row ,C= Column)"
              // rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="sheetTitle"
              label="Sheet Title(Optional)"
              // rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>

            <div>
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <th>HeaderNames</th>
                    <th>HeaderAreas</th>
                    <th>Function</th>
                  </tr>

                  {nodeData.pivotTable &&
                    nodeData.pivotTable.length > 0 &&
                    nodeData.pivotTable.map((row, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <input
                              style={{ height: "20px", width: "120px" }}
                              name="name"
                              value={row.name}
                              onChange={(e) => pivotHandleChange(e, row.id)}
                            />
                          </td>
                          <td>
                            <select
                              name="type"
                              value={row.type}
                              onChange={(e) => pivotHandleChange(e, row.id)}
                            >
                              <option value="ROW">As Row</option>
                              <option value="COLUMN">As Column</option>
                              <option value="VALUES">As Values</option>
                            </select>
                          </td>
                          <td>
                            {row.type === "VALUES" ? (
                              <select
                                name="function"
                                value={row.function}
                                onChange={(e) => pivotHandleChange(e, row.id)}
                              >
                                <option value="sum">Sum</option>
                                <option value="count">Count</option>
                                <option value="max">Max</option>
                                <option value="min">Min</option>
                              </select>
                            ) : (
                              <select
                                name="function"
                                value={row.function}
                                onChange={(e) => pivotHandleChange(e, row.id)}
                                disabled
                              >
                                <option value="">None</option>
                              </select>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
                <tfoot>
                  <tr>
                    <td>
                      <button
                        style={{ margin: "8px" }}
                        onClick={(e) => addClick(e)}
                      >
                        add
                      </button>
                      <button
                        style={{ margin: "8px" }}
                        onClick={(e) => removeClick(e)}
                      >
                        remove
                      </button>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        );

      default:
        return null;
    }
  };

  useEffect(() => {
    form.setFieldsValue(nodeData);
  }, [nodeData, form]);

  //  useEffect(() => {
  //    setNodeData(node);
  //    setActionType(node.actionType);
  //  }, []);
  const onChange = (allFields) => {
    handleSubmit(false);
  };
  return (
    <div>
      {nodeData ? (
        <div>
          <Form
            className=""
            form={form}
            initialValues={nodeData}
            onValuesChange={(_, allFields) => {
              onChange(allFields);
            }}
          >
            <div className="ant-row ant-form-item">
              <label className="ant-form-item-required">Select Operation</label>
              <div className="ant-col ant-form-item-control">
                <select
                  className="ant-input"
                  style={{ padding: "10px" }}
                  value={actionType}
                  onChange={(e) => handleTypeChange(e)}
                  rules={[{ required: true }]}
                >
                  <option value="select">Select</option>
                  {/* <option value="OPEN_SPREADSHEET">Open Spread Sheet</option> */}
                  <option value="GET_SHEET_NAMES">Get SheetNames</option>
                  <option value="GET_COLUMN">Get Column</option>
                  <option value="HIDE_COLUMN">Hide Column</option>
                  <option value="DELETE_COLUMN">Delete Column</option>
                  <option value="GET_ROW">Get Row</option>
                  <option value="DELETE_ROW">Delete Row</option>
                  <option value="GET_CELL">Get Cell</option>
                  <option value="WRITE_CELL">Write Cell</option>
                  <option value="GET_RANGE">Get Range</option>
                  <option value="WRITE_RANGE">Write Range</option>
                  <option value="APPEND_RANGE">Append Range</option>
                  <option value="FILTER_COLUMNS">Filter Columns</option>
                  <option value="GET_CELL_COLOR">Get Cell Color</option>
                  <option value="REFRESH_EXCEL">Refresh Excel</option>
                  <option value="GET_CELL_FORMULA">Get Cell Formula</option>
                  <option value="SET_RANGE_COLOR">Set Range Color</option>
                  <option value="DELETE_RANGE">Delete Range</option>
                  <option value="CONVERT_XLSX">Convert To XLSX</option>
                  <option value="INSERT_COLUMN">Insert Column</option>
                  <option value="CREATE_EXCEL">Create Excel</option>
                  {/* <option value="CREATE_PIVOT_TABLE">Create Pivot Table</option> */}
                  <option value="SORT_EXCEL_COLUMN">Sort Excel Data</option>
                  <option value="VLOOK_UP">Vlook Up</option>
                </select>
              </div>
            </div>

            {renderActionFields(actionType)}
          </Form>

          <GenAIConfigurer
            setNodeConfig={setNodeData}
            nodes={nodes}
            nodeData={nodeData}
            actionType={actionType}
          />

          <div>
            <Button onClick={cancel}> Cancel </Button>
            <Button
              type="primary"
              onClick={() => {
                handleSubmit(true);
              }}
            >
              Save
            </Button>
          </div>
        </div>
      ) : null}
      <ul className="note-list">
        {(() => {
          if (actionType === "GET_SHEET_NAMES") {
            return (
              <li>
                Returns a list of all the sheet names in the given workbook,
                ordered by their index.
              </li>
            );
          } else if (actionType === "GET_COLUMN") {
            return <li>Reads values from the specified column.</li>;
          } else if (actionType === "HIDE_COLUMN") {
            return <li>Hides the specified column from the spreadsheet.</li>;
          } else if (actionType === "DELETE_COLUMN") {
            return <li>Deletes the specified column from the spreadsheet.</li>;
          } else if (actionType === "GET_ROW") {
            return <li>Reads values from the specified row.</li>;
          } else if (actionType === "DELETE_ROW") {
            return <li>Deletes the specified row from the spreadsheet.</li>;
          } else if (actionType === "GET_CELL") {
            return <li>Reads value from the specified cell.</li>;
          } else if (actionType === "WRITE_CELL") {
            return <li>Writes value to the specified cell.</li>;
          } else if (actionType === "GET_RANGE") {
            return (
              <li>
                Reads values from the specified sheet range and stores it in a
                dataTable.
              </li>
            );
          } else if (actionType === "WRITE_RANGE") {
            return (
              <li>
                Writes values from the specified dataTable into the spreadsheet.
              </li>
            );
          } else if (actionType === "APPEND_RANGE") {
            return (
              <li>
                Adds the value from the specified dataTable at the end of the
                given excel sheet.
              </li>
            );
          } else if (actionType === "FILTER_COLUMNS") {
            return (
              <li>Filters the excel data based on the column conditions.</li>
            );
          } else if (actionType === "GET_CELL_COLOR") {
            return <li>Reads the colour of the specified excel cell.</li>;
          } else if (actionType === "REFRESH_EXCEL") {
            return <li>Refresh the excel file at the given path.</li>;
          } else if (actionType === "GET_CELL_FORMULA") {
            return <li>Reads the formula of the specified excel cell.</li>;
          } else if (actionType === "SET_RANGE_COLOR") {
            return <li>Sets the given colour to the specified range.</li>;
          } else if (actionType === "DELETE_RANGE") {
            return <li>Deletes the specified rannge from the spreadsheet.</li>;
          } else if (actionType === "CONVERT_XLSX") {
            return (
              <li>
                Converts the given csv or xls file formats into xlsx files
                format.
              </li>
            );
          } else if (actionType === "INSERT_COLUMN") {
            return <li>Inserts a column in the specified position.</li>;
          } else if (actionType === "VLOOK_UP") {
            return <li>Inserts a column in the specified position.</li>;
          } else if (actionType === "SORT_EXCEL_COLUMN") {
            return (
              <li>
                Sorts a specified column of excel file in ascending or
                descending order.
              </li>
            );
          } else if (actionType === "CREATE_EXCEL") {
            return <li>Creates an excel file at the given path.</li>;
          } else {
            return (
              <li>
                Performs various actions on the excel file located at the given
                path.
              </li>
            );
          }
        })()}
      </ul>
    </div>
  );
};

export default ExcelConfig;
